import type { RouteLocationNormalized } from 'vue-router'

// Navigations that change the URL but not the page — the Orders details drawer opening or closing over the list
// (KOVA-797). Only the view can tell a drawer from a page (it depends on the viewport), so it marks such a navigation
// in a `beforeEach`, and the router's `scrollBehavior` — the app's one scroll-on-navigation rule — leaves the window
// where it is. Keyed by the very location object vue-router hands both the guards and `scrollBehavior`, so a mark
// never outlives its navigation.
const kept = new WeakSet<RouteLocationNormalized>()

/** Leave the scroll as it is when this navigation lands. Call from a navigation guard, with the `to` it was given. */
export function keepScrollOn(to: RouteLocationNormalized): void {
	kept.add(to)
}

export function isScrollKept(to: RouteLocationNormalized): boolean {
	return kept.has(to)
}
